import {Directive, ElementRef, HostListener, Output, EventEmitter} from '@angular/core';
import {Debounced, Throttle} from '../utils/throttle';


@Directive({
  selector: '[appScroll]'
})
export class ScrollDirective {

  @Output() scrollChange = new EventEmitter<any>();

  constructor(
    private el: ElementRef,
  ) {
  }

  private throttle = new Throttle();
  private throttleUse = this.throttle.use(this.Click, this, 500);

  @HostListener('scroll', ['$event'])
  public onScroll(event): void {
    const params = {
      element: this.el,
      event
    };
    // 节流
    this.throttleUse(params);
  }

  private Click(params): void {
    this.scrollChange.next(params);
  }
}
